import { LitElement, html, css, unsafeCSS } from "lit";
import { styleMap } from "lit/directives/style-map.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export class FancyLineBreak extends LitElement {
	static styles = css`
		:host {
			display: block;
			--line-color: var(--color-primary, orange);
			--line-height: 2px;
			--line-rectangle-height: 10px;
			--line-rectangle-width: 40%;
			--line-rectangle-color: var(--color-primary, orange);
			--line-rectangle-position: 45%;
			--line-margin: 1em 0;
			width: 100%;
			min-width: 60px;
			align-self: center;
			justify-self: center;
		}
		.fancy-line-break {
			position: relative;
			display: flex;
			align-items: center;
			margin: var(--line-margin);
			height: var(--line-height);
			background-color: var(--line-color);
			width: 100%;
		}

		.fancy-line-break:before {
			content: "line rectangle decoration";
			position: absolute;
			display: block;
			left: var(--line-rectangle-position);
			width: var(--line-rectangle-width);
			height: var(--line-rectangle-height);
			background-color: var(--line-rectangle-color);
			max-width: 100%;
			color: transparent;
		}
	`;

	static properties = {
		lineColor: { attribute: "line-color", reflect: true },
		lineHeight: { reflect: true, attribute: "line-height" },
		lineRectangleHeight: { reflect: true, attribute: "rectangle-height" },
		lineRectangleWidth: { reflect: true, attribute: "rectangle-width" },
		lineRectangleColor: { reflect: true, attribute: "rectangle-color" },
		lineRectanglePosition: { reflect: true, attribute: "rectangle-position" },
	};

	constructor() {
		super();

		this.lineColor = "";
		this.lineHeight = "";
		this.lineRectangleHeight = "";
		this.lineRectangleWidth = "";
		this.lineRectangleColor = "";
		this.lineRectanglePosition = "";

		this.propMap = new Map();

		this.propMap.set("lineColor", ["--line-color", ""]);
		this.propMap.set("lineHeight", ["--line-height", "px"]);
		this.propMap.set("lineRectangleHeight", ["--line-rectangle-height", "px"]);
		this.propMap.set("lineRectangleWidth", ["--line-rectangle-width", "%"]);
		this.propMap.set("lineRectangleColor", ["--line-rectangle-color", ""]);
		this.propMap.set("lineRectanglePosition", ["--line-rectangle-position", "%"]);

		this.changedStyles = {};
		this.newChangedStyles = "";
	}

	willUpdate(changedProps) {
		/*		console.log("hi");
		console.log(changedProps);
		console.log(this.lineColor);*/

		this.newChangedStyles = "";

		changedProps.forEach((value, key) => {
			if (this[key] && !isEmptyObj(this[key]) && this[key] !== "changedStyles") {
				const valueProps = this.propMap.get(key);
				if (valueProps !== undefined) {
					const rootKey = valueProps[0];
					let styleProp = "";
					if (valueProps) {
						styleProp = valueProps[1];
					}

					this.changedStyles[`${rootKey}`] = this[key] + styleProp;
				}
			}
		});

		Object.keys(this.changedStyles).forEach((value, key) => {
			this.newChangedStyles += ` ${value}: ${this.changedStyles[value]};`;
		});

		/*if (!isEmptyObj(this.changedStyles)) {
			for (let [styleKey, value] of Object.entries(this.changedStyles)) {
				this.newChangedStyles += ` ${styleKey}: ${this[this.propMap.get(styleKey)]}${value[1]};`;
			}
		}*/

		//this.render();
	}

	render() {
		let styles = "";
		return html` <style>
				${this.newChangedStyles}
			</style>
			<div class="fancy-line-break" style="${this.newChangedStyles}"></div>`;
	}
}
function isEmptyObj(obj) {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
}
window.customElements.define("fancy-line-break", FancyLineBreak);
